import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import $ from 'jquery';
import moment from 'moment';
import * as Pikaday from 'pikaday';
import classnames from 'classnames';
import TourAvailabilityActionCreator from 'action_creators/tour_availability';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import { injectIntl } from 'react-intl';
import 'pikaday/css/pikaday.css';
import './calendar.scss';
import { createDatepickerConfig } from '../datepicker_language_configuration/Datepicker_configuration';

const Calendar = createReactClass({
  displayName: 'DropdownCalendar',

  propTypes: {
    tourId: PropTypes.number.isRequired,
    availableDates: PropTypes.object.isRequired,
    isLoadingAvailableDates: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    valueFormat: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.element,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    intl: PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {
      disabled: false,
    };
  },

  getInitialState() {
    return {
      pikaday: this._pikadayCreate(),
      currentMonth: this.props.value
        ? moment(this.props.value, this.props.valueFormat).toDate()
        : new Date(),
      ariaExpanded: false,
    };
  },

  componentDidMount() {
    $(this.refs.calendar).append(this.state.pikaday.el);
    this.state.pikaday.setDate(
      moment(this.props.value, this.props.valueFormat).toDate()
    );
  },

  componentDidUpdate(prevProps) {
    this.state.pikaday.gotoDate(this.state.currentMonth);
    if (
      this.props.value !== prevProps.value &&
      this.props.value !== this.state.pikaday.toString()
    ) {
      this.state.pikaday.setDate(
        moment(this.props.value, this.props.valueFormat).toDate()
      );
    }
  },

  isVisible() {
    return this.state.pikaday.isVisible();
  },

  getFirstAvailableDate() {
    if (this.props.availableDates) {
      return Object.keys(this.props.availableDates).sort()[0];
    }
  },

  showCalendar() {
    const gotoDate = this.props.value
      ? this.props.value
      : this.getFirstAvailableDate();
    const gotoDateFormat = this.props.value
      ? this.props.valueFormat
      : 'YYYY-MM-DD';

    if (gotoDate) {
      this.state.pikaday.gotoDate(moment(gotoDate, gotoDateFormat).toDate());
    }

    this.state.pikaday.show();
    this.setState({ ariaExpanded: true });
  },

  hideCalendar() {
    this.state.pikaday.hide();
    this.setState({ ariaExpanded: false });
  },

  toggleCalendar() {
    if (!this.props.disabled) {
      if (this.state.pikaday.isVisible()) {
        this.hideCalendar();
      } else {
        this.showCalendar();
      }
    }
  },

  // Returns day of week to start with
  // 0 => Sunday
  // 1 => Monday
  weekStartDay() {
    if (this.props.weekStartDay === 0) return 0;
    if (this.props.weekStartDay > 0) return this.props.weekStartDay;
    return 1;
  },

  _pikadayCreate() {
    const _this = this;
    const pikadaySettings = {
      disableDayFn: this._pikadayDisableDayFn,
      format: this.props.valueFormat,
      firstDay: this.weekStartDay(),
      /* `onDraw` is about the only place to hook into pikaday's change date event */
      onDraw() {
        if (
          _this.state.currentMonth.getFullYear() !== this.calendars[0].year ||
          _this.state.currentMonth.getMonth() !== this.calendars[0].month
        ) {
          _this._loadAvailability();
        }
      },

      onSelect() {
        _this.hideCalendar();
        _this.props.onChange(_this.props.name, this.toString());
      },
    };
    const datePickerLanguageSpecificSettings =
      this._datePickerLanguageSpecificSettings();
    const pikadaySettingsWithLang = {
      ...pikadaySettings,
      ...datePickerLanguageSpecificSettings,
    };

    // Currently simplest way for checking whether Spanish translated tour
    // since accessing tour prop itself is not as easy. in future, with multi-languages,
    // will need to refactor.
    const { intl } = this.props;
    pikadaySettingsWithLang.i18n = createDatepickerConfig(intl);
    const pikaday = new Pikaday(pikadaySettingsWithLang);

    pikaday.hide();

    return pikaday;
  },

  _datePickerLanguageSpecificSettings() {
    const { intl } = this.props;
    const locale = intl.locale.toLowerCase();
    const settings = {
      yearSuffix: '',
      showMonthAfterYear: false,
    };
    if (locale === 'zh-cn' || locale === 'zh-tw') {
      settings.yearSuffix = ' \u5e74';
      settings.showMonthAfterYear = true;
    }
    return settings;
  },

  _pikadayDisableDayFn(date) {
    return !this.props.availableDates.hasOwnProperty(
      moment(date).format('YYYY-MM-DD')
    );
  },

  _loadAvailability() {
    const currentMonth = new Date(
      this.state.pikaday.calendars[0].year,
      this.state.pikaday.calendars[0].month
    );
    const { from, to } = this._fromToFromCurrentMonth(currentMonth);

    const { value } = this.props.location || {};
    const { id } = value || {};

    this.setState({ currentMonth });
  },

  _fromToFromCurrentMonth(currentMonth) {
    const currentMonthMoment = moment(currentMonth);
    const from = currentMonthMoment.startOf('month').format('YYYY-MM-DD');
    const to = currentMonthMoment.endOf('month').format('YYYY-MM-DD');

    return { from, to };
  },

  _label() {
    const { intl } = this.props;
    return intl.formatDate(moment(this.props.value).toDate(), {
      month: 'short',
      day: 'numeric',
    });
  },

  render() {
    const klassName = classnames('ui compact dropdown selection inline', {
      disabled: this.props.disabled,
    });
    const { ariaExpanded } = this.state;
    return (
      <div
        data-testid="dropdown-calendar"
        className={classnames('DropdownCalendar', {
          disabled: this.props.disabled,
        })}
      >
        <button
          type="button"
          data-testid="calendar-select"
          id="checkout-calender"
          className={klassName}
          onClick={this.toggleCalendar}
          aria-expanded={ariaExpanded}
          onKeyDown={(e) => isActionKey(e.key) && this.toggleCalendar()}
        >
          {this.props.value ? (
            <div className="text">{this._label()}</div>
          ) : (
            <div className="default text">{this.props.placeholder}</div>
          )}

          {this.props.icon}
        </button>

        <div className="calendar-wrapper">
          <div
            className={`ui segment ${
              this.props.isLoadingAvailableDates ? 'loading' : ''
            }`}
          >
            <div
              className="calendar notranslate"
              data-testid="calendar-widget"
              ref="calendar"
              aria-label="select date"
              tabIndex={0}
            />
          </div>
        </div>
      </div>
    );
  },
});

export default injectIntl(Calendar);
